export const GRID_IMAGES_SLICE_TYPE = 'solution_grid_images';

export const MAX_GRID_IMAGES = 10;
